import React, { Component } from 'react';
import { get } from '../utils/request';
import { regExpression, isPhone, constant, scrollToAnchor } from '../utils/util';
import { CommonOptionSelect,CommonInput,CommonTextarea, KryptisLaukas, CompanyName} from './common';
import { UploadBP } from '../components/groupProject'

class ProjectInfoClass2 extends Component {
  static defaultProps = { }
  constructor(props) {
    super(props);
    this.state = { ...props}
    this.debug = false
    this.debug && console.log("[ProjectInfoClass2] ---- props  state------>" + JSON.stringify(this.state))
  }
  componentDidMount() {
    this.emitData()
  }
  onSelectProjectRound = (data) => {
    this.debug && console.log("[ProjectInfoClass2] onSelectProjectRound --> " +  JSON.stringify(data))
    this.setState({ ...data }, () => { this.emitData()});
  }
  onCommonValueChange = (data) => {
    this.setState(data)
    console.log("[ProjectInfoClass2] onCommonValueChange --> " +  JSON.stringify(this.state))
    this.setState({ ...data }, () => { this.emitData()});
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis' && this.state.industry) {
        this.state.industry[0] = resObj[index] ;
      }
      if (index === 'laukas' && this.state.industry) {
        this.state.industry[1] = resObj[index];
      }
    }
    this.setState({ ...resObj }, () => { this.emitData() });
  }

  emitData = () => {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }

  validateFunction = () => {
    let flag = true
    const validateMap = new Map();
    // let projectVliArr = ['company_name', 'position', 'name', 'industry','financing_stage','intro', 'is_need'];
    let projectVliArr = ['position', 'industry'];
    validateMap.set('projectValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('projectValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      if (i === 'industry' && validateMap.get('projectValidate').indexOf(i) > -1 && (!this.state[i][0] || !this.state[i][1])) {
        flag = false;
      }
    }
    return flag;
  }

  render() {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    if (!this.state.industry) {
      this.state.industry = ['', ''];
    }
    return (
      <div>
        { this.debug &&
          <div>
            <p> user role with Project info : </p>
            <p> {JSON.stringify(this.props,null,2) }</p>
          </div>
        }
        {
          <CompanyName
            company={this.state.company_name}
            checkErr= {this.props.checkErr}
            onValueChange={this.onCommonValueChange}/>
        }
        {
          false && this.props.userRole == 3 && 
          <CommonInput
            title = {"公司名称:"}
            name = {"company_name"}
            value = {this.state.company_name}
            checkErr= {this.props.checkErr}
            errorMsg={"请填写"}
            onValueChange={this.onCommonValueChange}/>
        }
        <CommonInput
          title = {"公司职位:"}
          name = {"position"}
          value = {this.state.position}
          checkErr= {this.props.checkErr}
          errorMsg={"请填写"}
          onValueChange={this.onCommonValueChange}/>
        {
          this.props.userRole != 3 && 
          <CommonInput
            title = {"项目名称:"}
            name = {"name"}
            value = {this.state.name}
            checkErr= {this.props.checkErr}
            errorMsg={"请填写"}
            onValueChange={this.onCommonValueChange}/>
        }
        <KryptisLaukas
          {...kryptisLaukas}
          recive_title={ this.props.userRole == 3 ? '公司行业' : '项目行业/领域'}
          checkErr= {this.props.checkErr}
          errorMsg={"请选择"}
          onValueChange={this.handleValueChange}
        />

        {
          // 报名角色为公司职员时，报名字段为公司名称、公司职位、公司行业，公司简介，去掉项目轮次、是否需要融资，资本对接等项。
          this.props.userRole != 3 && 
          <div>
            <CommonOptionSelect
              title={'项目轮次:'}
              name={"financing_stage"}
              selectedVal={this.state.financing_stage}
              checkErr= {this.props.checkErr}
              option_list={regExpression().financingRoundAll}
              onSelectOption={ this.onSelectProjectRound}/>
            <CommonTextarea
              title = {"项目简介:"}
              holder = {"请填写 (800字以内)"}
              name = {"intro"}
              maxLength={800}
              value = {this.state.intro}
              checkErr= {this.props.checkErr}
              onValueChange={this.onCommonValueChange}/>
            <CommonOptionSelect
              title={'是否需要融资:'}
              name={"is_need"}
              selectedVal={this.state.is_need}
              option_list={['需要', '不需要']}
              onSelectOption={ this.onCommonValueChange}/>
            <UploadBP onValueChange={this.handleValueChange}/>
          </div>
        }
        {
          this.props.userRole == 3 && 
          <CommonTextarea
          title = {"公司简介:"}
          holder = {"请填写 (800字以内)"}
          name = {"intro"}
          maxLength={800}
          value = {this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.onCommonValueChange}/>
        }

      </div>
    )
  }
}
export default ProjectInfoClass2;
